import React, { useState, useEffect } from 'react';
import { Icon, Table, Link, Message } from '@b-design/fusion';
import { MenuButton } from '@alifd/next';
// import { history } from 'ice';
import $i18n from '../../../../../i18n';
import PublishedAppListIcons from '@/components/PublishedAppListIcons';
// import { dataVersion } from './dataVersion.js';
import SubVersionTable from '../subVersionTable';
import ChooseChannelModal from '../chooseChannelModal';
import FileUploadModal from '../fileUploadModal';
import PaginationComponent from '@/components/PaginationComponent';
import CalculateComponent from '@/components/CalculateComponent';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import { formatTime } from '@/utils';
import langObj from '@/i18n';
import store from '@/store';

import './index.less';

interface Record {
  [key: string]: any;
}

interface Props {
  currentTabKey: string;
  info: any;
}

const { Item } = MenuButton;

const Version: React.FC<Props> = ({ currentTabKey, info }) => {
  const [channelVisible, setChannelVisisble] = useState(false);
  const [currInfo, setCurrInfo] = useState<Record>({});
  // const [chooseChannelVisible, setChooseChannelVisible] = useState(false);
  const [fileVisible, setFileVisible] = useState(false);
  const [contentHeight, setContentHeight] = useState(296);
  const { appId } = getQueryStringArgs();
  // 分页参数
  const [paginationValue, setPaginationValue] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const [tableData, setTableData] = useState({ totalCount: 0, data: [] }); // 列表数据和总条数
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [maxVersion, setMaxVersion] = useState('');
  const { spaceId } = getQueryStringArgs();
  const [spaceRoleState] = store.useModel('spaceRole');

  const initData = (params) => {
    if (!spaceId) {
      return;
    };
    let dataList: any = [];
    let dataTotal = 0;
    setLoading(true);

    Requests.get('/rest/intercnn/publishChannel/pageQuery', {
      draftStatus: 'ONLINE',
      spaceId,
      belongSpaceId: spaceRoleState?.belongSpaceId || '',
    }).then((resData) => {
      if (resData) {
        Requests.get('/rest/intercnn/app/version/query', { ...params, appId, spaceId }).then(
          (data) => {
            if (data) {
              const { total = 0, list = [] } = data;
              for (let i = 0; i < list.length; i++) {
                list[i].id = i;
                list[i].children = [];
              }
              dataList = list;
              dataTotal = total;

              setMaxVersion(list[0]?.version);

              if (dataList.length > 0) {
                Requests.get('/rest/intercnn/app/publish/version/query', {
                  appId,
                  version: dataList[0].version,
                }).then((data) => {
                  if (data) {
                    const { list: listVer = [] } = data;
                    dataList[0].children = listVer;

                    Requests.get('/rest/intercnn/app/publish/version/query', {
                      appId,
                      pageSize: 999,
                      currentPage: 1,
                    }).then((data) => {
                      if (data) {
                        const { list = [] } = data;
                        const obj: any = {};
                        list.forEach((item) => {
                          if (!obj[item.version]) {
                            obj[item.version] = [item.channelIcon];
                          } else {
                            obj[item.version].push(item.channelIcon);
                          }
                        });
                        for (let i = 0; i < dataList.length; i++) {
                          dataList[i].icons = obj[dataList[i].name];
                          dataList[i].isShow = obj[dataList[i].name]?.length !== resData.total;
                        }

                        setTableData({
                          totalCount: dataTotal,
                          data: dataList,
                        });
                        setLoading(false);
                      }
                    });
                  }
                });
              } else {
                setLoading(false);
              }
            }
          },
        );
      }
    });
  };

  useEffect(() => {
    if (flag) {
      initData({ currentPage: 1, pageSize: 10 });
      setFlag(false);
    }
  }, [flag]);

  useEffect(() => {
    if (currentTabKey === 'Versions') {
      initData(paginationValue);
    }
  }, [currentTabKey]);

  const pageChangeHandler = (current: number, pageSize: number) => {
    const payload = {
      currentPage: current,
      pageSize,
    };

    setPaginationValue({
      currentPage: current,
      pageSize,
    });
    initData(payload);
  };

  const menu = [
    $i18n.get({ id: 'aopf.pages.miniapp.versions.IDE.Build', dm: 'IDE构建' }),
    $i18n.get({ id: 'aopf.pages.miniapp.versions.File.Upload', dm: '文件上传' }),
  ].map((item) => (
    <Item
      key={item}
      onClick={() => {
        if (item === $i18n.get({ id: 'aopf.pages.miniapp.versions.File.Upload', dm: '文件上传' })) {
          setFileVisible(true);
        } else {
          // TODO 需求链接 https://aliyuque.antfin.com/e2intl/fogqu1/zckwevr4egma9vka
          window.open('//www.alibabacloud.com/help/superapp/latest/build-and-upload-versions');
          // langObj.language === 'en-US'
          // ? window.open(
          //   '/portal?lang=en#/document/superapp/superapp-bap-public-intl/build-and-upload-versions',
          // )
          //   : window.open(
          //     '/portal?lang=zh#/document/superapp/superapp-bap-public-intl/build-and-upload-versions',
          //   );
        }
      }}
    >
      {item}
    </Item>
  ));

  const menuUniapp = [
    $i18n.get({ id: 'aopf.pages.miniapp.versions.File.Upload', dm: '文件上传' }),
  ].map((item) => (
    <Item
      key={item}
      onClick={() => {
        setFileVisible(true);
      }}
    >
      {item}
    </Item>
  ));

  const renderPublish = (value) => {
    return <PublishedAppListIcons value={value} />;
  };

  const actions = (value, index, record) => {
    return (
      <div className="actions-content">
        {record.isShow ? (
          <Link
            style={{
              padding: '0 5px',
              fontSize: '12px',
              color: 'var(--superapp-primary-1)',
              letterSpacing: '0.4px',
              lineHeight: '20px',
            }}
            onClick={() => {
              setChannelVisisble(true);
              setCurrInfo(record);
            }}
          >
            <Icon type="send--outline" />
            {$i18n.get({
              id: 'aopf.pages.miniapp.versions.table.subTable.action.Release',
              dm: '发布',
            })}
          </Link>
        ) : null}
      </div>
    );
  };

  const expandedRowRender = (record) => {
    const { children } = record;
    return <SubVersionTable dataSource={children} subLoading={subLoading} />;
  };

  const renderSource = (value) => {
    let iconType = 'cloud--upload';
    let title = '';
    if (value === 'DEVOPS') {
      iconType = 'cloud--upload';
      title = 'Cloud Build';
    } else if (value === 'IDE') {
      iconType = 'equipment--outline';
      title = 'IDE';
    } else {
      iconType = 'gongwenbao_xianxing';
      title = 'File';
    }
    return (
      <div className="version-source-content">
        <div className="version-source-icons">
          <Icon type={iconType} size="xs" />
        </div>
        <span className="version-source-title">{title}</span>
      </div>
    );
  };

  const onRowOpen = (openRowKeys, currentRowKey, expanded, currentRecord) => {
    if (expanded) {
      setSubLoading(true);
      Requests.get('/rest/intercnn/app/publish/version/query', {
        appId,
        version: currentRecord.version,
      }).then((data) => {
        if (data) {
          const { list = [] } = data;
          let temp: any = [];
          temp = tableData;
          temp.data[currentRowKey].children = list;
          setSubLoading(false);
          setTableData(temp);
        }
      });
    }
  };

  const downloadApp = (appId, version) => {
    Requests.get('/rest/intercnn/app/version/download', {
      appId,
      version,
    }).then((data) => {
      if (!data?.downloadUrl) {
        Message.error({
          title: $i18n.get({ id: 'aopf.component.versions.DownloadFailed', dm: '下载失败' }),
        });
        return;
      }
      window.open(data.downloadUrl);
    });
  };
  const toJsapiTab = (type) => {
    const sendEvent = new CustomEvent('toApplyMiniappDetailsTab', {
      detail: {
        name: 'toApplyMiniappDetailsTab',
        type,
      },
    });
    document.dispatchEvent(sendEvent);
  };

  return (
    <div className="global-filter-list">
      <div className="versions-content list-content">
        <div className="menu-btn-div">
          <MenuButton
            type="primary"
            label={$i18n.get({ id: 'aopf.pages.miniapp.versions.btn.Add.Version', dm: '添加版本' })}
            style={{
              marginBottom: 24,
              fontWeight: 500,
              fontSize: 14,
              color: '#FFFFFF',
              letterSpacing: 0.4,
              borderRadius: 4,
            }}
            popupTriggerType="hover"
          >
            {info.framework === 'UniApp' ? menuUniapp : menu}
          </MenuButton>
        </div>

        {currentTabKey === 'Versions' ? (
          <Table
            dataSource={tableData.data}
            // onSort={onSort}
            loading={loading}
            expandedRowRender={expandedRowRender}
            style={{ height: contentHeight }}
            onRowOpen={onRowOpen}
            key={paginationValue.currentPage}
            defaultOpenRowKeys={[0]}
          >
            <Table.Column
              title={$i18n.get({ id: 'aopf.pages.miniapp.versions.table.Version', dm: '版本' })}
              dataIndex="version"
              // sortable
              cell={(value, _, record) => {
                return (
                  <span
                    className="version-cell"
                    onClick={() => downloadApp(record.appId, record.version)}
                  >
                    {value && `v${value}`}
                  </span>
                );
              }}
              width={90}
            />

            <Table.Column
              title={$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Published.App',
                dm: '目标渠道',
              })}
              dataIndex="icons"
              cell={renderPublish}
              width={220}
            />

            <Table.Column
              title={$i18n.get({ id: 'aopf.pages.miniapp.versions.table.Source', dm: '版本来源' })}
              dataIndex="source"
              cell={renderSource}
              width={200}
            />

            <Table.Column
              title={$i18n.get({
                id: 'aopf.pages.miniapp.versions.table.Created.On',
                dm: '上传时间',
              })}
              dataIndex="gmtCreate"
              cell={(value) => {
                return formatTime(value);
              }}
              width={180}
            />

            <Table.Column
              title={$i18n.get({ id: 'aopf.pages.miniapp.versions.table.Creator', dm: '上传人' })}
              dataIndex="createName"
              width={180}
            />

            <Table.Column
              title={$i18n.get({ id: 'aopf.pages.miniapp.versions.table.Action', dm: '操作' })}
              cell={actions}
              width={100}
            />
          </Table>
        ) : null}

        <PaginationComponent
          total={tableData.totalCount}
          current={paginationValue.currentPage}
          pageSize={paginationValue.pageSize}
          onPageChange={pageChangeHandler}
        />

        <CalculateComponent
          otherWidth={280}
          otherHeight={108 + 80 + 140}
          windowChange={(_width, height) => {
            setContentHeight(height);
          }}
        />

        <ChooseChannelModal
          info={info}
          channelVisible={channelVisible}
          toJsapiTab={toJsapiTab}
          setChannelVisisble={setChannelVisisble}
          currInfoVersion={currInfo.version}
        />

        <FileUploadModal
          fileVisible={fileVisible}
          setFileVisible={setFileVisible}
          setFlag={setFlag}
          info={info}
          maxVersion={maxVersion}
        />
      </div>
    </div>
  );
};

export default Version;
